import { GetScore, Lifter, Meet } from "types";
import { toKg, toLbs } from "util/conversions";
import { getTotal } from "util/lifterHelper";
import { isKgMeet, isLbsMeet } from "util/meetHelper";

export const ahPoints = function (total: number, lifter: Lifter, meet: Meet) {
  let bodyWeight = lifter.bodyWeight;

  if (!bodyWeight) {
    return 0;
  }

  if (!lifter.gender || lifter.gender === "MX") {
    return 0;
  }

  if (total <= 0) {
    return 0;
  }

  const parameters = {
    MALE: {
      a: 3.2695,
      b: 1.95,
    },
    FEMALE: {
      a: 2.7566,
      b: 1.8,
    },
  };

  if (isKgMeet(meet)) {
    bodyWeight = toLbs(bodyWeight);
  }

  const a = parameters[lifter.gender].a;
  const b = parameters[lifter.gender].b;

  return a * (total / Math.pow(b, Math.log(bodyWeight)));
};

export const getAhPoints: GetScore = ({
  lifter,
  division,
  meet,
  forecasted,
}) => {
  let total = getTotal({ lifter, division, meet, forecasted });
  if (isLbsMeet(meet)) {
    total = toKg(total);
  }

  return ahPoints(total, lifter, meet);
};
